import { Component } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent {
    yr: Date = new Date();
    public version: string = environment.version;

}
